export default "/_next/static/images/NewPlayIconMobile-8cc20538f563bfb6ec8c606f4802feb3.svg";